import { EnvironmentType } from '@/react/portainer/environments/types';
import { getPlatformTypeName } from '@/react/portainer/environments/utils';

import { BadgeType } from '@@/Badge';

export function getEdgeGroupPlatformBadge(
  endpointTypes: Array<EnvironmentType>
): { label: string; type: BadgeType } {
  const platforms = new Set(
    endpointTypes.map((type) => getPlatformTypeName(type))
  );

  return platforms.size > 1
    ? { label: 'Mixed', type: 'success' }
    : { label: [...platforms][0] ?? 'Mixed', type: 'info' };
}
